import React from 'react';
export const MechanismSection = () => {
  return <section className="bg-gradient-to-b from-teal-700 to-teal-600 text-white py-16" data-id="element-283">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-284">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center" data-id="element-285">
          The Unique Mechanism That Powers Neurotoned:
        </h2>
        <h3 className="text-2xl font-semibold mb-8 text-center" data-id="element-286">
          The 4-Layer Nervous System Healing Stack
        </h3>
        <div className="mb-10 max-w-2xl mx-auto" data-id="element-287">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/n1mjfwQaGVcc68mfnupbsc/17cef8e-2885-4324-66a2-30e65137f44_fibromyalgiaNervePainBrain-1067733668-770x553_jpg_%281%29.webp" alt="Brain with neural connections illustration" className="w-full rounded-lg shadow-xl mb-8" data-id="element-288" />
          <p className="text-lg font-bold mb-6 text-center" data-id="element-289">
            <strong data-id="element-290">We don't throw random somatic tools at you.</strong> We
            sequence them intentionally across 4 healing layers:
          </p>
          <div className="space-y-8" data-id="element-291">
            <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-292">
              <h4 className="text-xl font-bold mb-3" data-id="element-293">
                1. Physiological Safety:
              </h4>
              <ul className="list-disc pl-6 space-y-2" data-id="element-294">
                <li data-id="element-295">Reset your vagus nerve</li>
                <li data-id="element-296">Build capacity without overwhelm</li>
                <li data-id="element-297">Feel safe in your body again</li>
              </ul>
            </div>
            <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-298">
              <h4 className="text-xl font-bold mb-3" data-id="element-299">
                2. Sensory Integration:
              </h4>
              <ul className="list-disc pl-6 space-y-2" data-id="element-300">
                <li data-id="element-301">Use sound, touch, and breath to unlock freeze states</li>
                <li data-id="element-302">Discharge stored trauma patterns</li>
              </ul>
            </div>
            <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-303">
              <h4 className="text-xl font-bold mb-3" data-id="element-304">
                3. Expressive Reconnection:
              </h4>
              <ul className="list-disc pl-6 space-y-2" data-id="element-305">
                <li data-id="element-306">Move trauma out through movement, art, and sound</li>
                <li data-id="element-307">Reclaim emotional expression without retraumatization</li>
              </ul>
            </div>
            <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-308">
              <h4 className="text-xl font-bold mb-3" data-id="element-309">
                4. Resilience & Regulation:
              </h4>
              <ul className="list-disc pl-6 space-y-2" data-id="element-310">
                <li data-id="element-311">Daily practices to stabilize calm</li>
                <li data-id="element-312">Tools for triggers, shutdown, and dissociation</li>
              </ul>
            </div>
          </div>
          <p className="mt-8 text-lg text-center" data-id="element-313">
            Each day builds on the last. You're not just learning... you're{' '}
            <em data-id="element-314">rewiring.</em>
          </p>
        </div>
      </div>
    </section>;
};